import { Menu } from 'lucide-react';
import type { ReactNode } from 'react';

export function Topbar({
  title,
  onHamburger,
  right,
}: {
  title: string;
  onHamburger: () => void;
  right?: ReactNode;
}) {
  return (
    <header className="sticky top-0 z-30 bg-white/95 backdrop-blur-sm border-b border-border shadow-[0_1px_2px_rgba(0,0,0,0.04)] flex items-center gap-4 px-6 lg:px-10 min-h-16">
      <button
        aria-label="menu"
        onClick={onHamburger}
        className="lg:hidden w-10 h-10 -ml-1 rounded-xl flex items-center justify-center text-brown hover:bg-cream transition-colors"
      >
        <Menu className="w-5 h-5" />
      </button>
      <h1 className="font-display font-bold text-base lg:text-lg text-brown">{title}</h1>
      <div className="ml-auto flex items-center gap-2">{right}</div>
    </header>
  );
}
